import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../../images/logo.jpeg";
import { login } from "../../apis/AuthenticationAPI";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { checkIfNotEmpty } from "../../utils/utils";
const cookies = new Cookies();

const Login = () => {
  toast.configure();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginData, setLoginData] = useState({});
  const history = useHistory();

  const token = cookies.get("token");

  useEffect(() => {
    if (checkIfNotEmpty(token)) {
      history.push("/");
    }
  }, []);

  const handleBlur = (e) => {
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
  };
  const submitHandler = (e) => {
    e.preventDefault();
    console.log(e);
    login(username, password)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          cookies.set("token", response.data.token, { path: "/" });
          cookies.set("user_role", response.data.user_role, { path: "/" });

          if (response.data.user_role === "admin") {
            history.replace("/");
          } else if (response.data.user_role === "blog_user") {
            history.replace("/table-posts");
          }

          toast.success("Login Successful", {
            position: "top-left",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: false,
          });
        }
      })
      .catch((error) => {
        console.log("Error is ", error.response);
        toast.error("Error while logging in : " + error.response.data.message, {
          position: "top-left",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: false,
        });
      });
  };
  return (
    <div className="row justify-content-center h-100 align-items-center h-80">
      <div className="col-md-6">
        <div className="authincation-content">
          <div className="row no-gutters">
            <div className="col-xl-12">
              <div className="auth-form">
                <div className="text-center mb-3">
                  <Link to={"/"}>
                    <img src={logo} alt="" height={100} width={100} />
                  </Link>
                </div>
                <h4 className="text-center mb-4 text-white">
                  {" "}
                  Sign in your account{" "}
                </h4>
                <form
                  action=""
                  onSubmit={(e) => e.preventDefault(submitHandler)}
                >
                  <div className="form-group">
                    <label className="mb-1 text-white">
                      {" "}
                      <strong>Email</strong>{" "}
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="mb-1 text-white ">
                      {" "}
                      <strong>Password</strong>{" "}
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="form-row d-flex justify-content-between mt-4 mb-2">
                    <div className="form-group">
                      <div className="custom-control custom-checkbox ml-1 ">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="basic_checkbox_1"
                        />
                        <label
                          className="custom-control-label text-white"
                          htmlFor="basic_checkbox_1"
                        >
                          {" "}
                          Remember my preference{" "}
                        </label>
                      </div>
                    </div>
                    <div className="form-group">
                      <Link className="text-white" to="/page-forgot-password">
                        {" "}
                        Forgot Password?{" "}
                      </Link>
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn bg-white text-primary btn-block"
                      onClick={(e) => submitHandler(e)}
                    >
                      {" "}
                      Sign Me In{" "}
                    </button>
                  </div>
                </form>
                <div className="new-account mt-3">
                  <p className="text-white">
                    {" "}
                    Don't have an account?{" "}
                    <Link className="text-primary" to="/page-register">
                      {" "}
                      Sign up{" "}
                    </Link>{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
